// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1Pkfx","label":"SetPasswdForm_label__20mhO"};